/* eslint react/require-default-props: 0 */
import React from 'react';
import Modal from '@carvana/showroom-modal';
import DocWarningIcon from '../../../../assets/doc-warning-icon';
import {
  IconImage,
  ModalTitle,
  ModalContent,
  ModalMessage,
  SadCarImage,
  SupportMessage,
  HyperLink,
} from './BankError.styles';
import { currentAssetsUrl } from '../../../../utils/baseUrlUtil';

const BankError = (props: {
  isOpen: boolean;
  setBankError: any;
  category?: any;
}) => {
  const { isOpen, setBankError, category } = props;

  const closeModal = () => {
    setBankError(false);
  };

  const InvalidRoutingError = () => {
    return (
      <Modal
        headerText="Update Bank Details"
        closeModal={closeModal}
        isOpen={isOpen}
        testHook="payment-error-modal"
        mode="light"
        portalDivId="payment-error"
      >
        <ModalContent>
          <IconImage>
            <DocWarningIcon />
          </IconImage>
          <ModalTitle>Invalid Routing Number Entered</ModalTitle>
          <ModalMessage>Please enter a valid routing number.</ModalMessage>
        </ModalContent>
      </Modal>
    );
  };

  const Error = () => {
    return (
      <Modal
        headerText="Oops, something went wrong"
        closeModal={closeModal}
        isOpen={isOpen}
        testHook="payment-error-modal"
        mode="light"
        portalDivId="payment-error"
      >
        <ModalContent>
          <SadCarImage
            src={`${currentAssetsUrl(
              process.env.NODE_ENV
            )}/emblem/90f86c4a-2ce5-4586-8004-e2c3c9b89ab1.svg`}
          />
          <ModalTitle>OOPS, SORRY!</ModalTitle>
          <ModalMessage>
            Something went wrong. The information you entered may be incorrect.
            We are unable to connect to your bank account
          </ModalMessage>
          <SupportMessage>
            Please call Bridgecrest support at:{' '}
            <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>
            <span>
              Or manage at:{' '}
              <HyperLink href="www.bridgecrest.com" target="_blank" type="external">
                www.bridgecrest.com
              </HyperLink>
            </span>
          </SupportMessage>
        </ModalContent>
      </Modal>
    );
  };

  return (
    <>{category === 'Invalid Routing' ? <InvalidRoutingError /> : <Error />}</>
  );
};

export default BankError;
